
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";
import RSEHero from "@/components/rse/RSEHero";
import RSEServices from "@/components/rse/RSEServices";
import RSEBenefits from "@/components/rse/RSEBenefits";
import RSEValocap from "@/components/rse/RSEValocap";

const PrestationRSE = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <SEO 
        title="Prestation RSE - Groupe Fabre Environnement" 
        description="Accompagnement global pour une gestion responsable et durable de vos déchets. Services RSE personnalisés pour votre entreprise." 
        canonical="/nos-services/prestation-rse" 
      />
      <Navbar />
      
      <main className="flex-1">
        <RSEHero />
        <RSEServices />
        <RSEBenefits />
        <RSEValocap />
      </main>

      <Footer />
    </div>
  );
};

export default PrestationRSE;
